/* eslint-disable camelcase */
import { Button, Dialog, DialogActions, DialogContent, Grid2, Stack } from '@mui/material'
import Select from 'components/forms/Select'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Textarea from 'components/forms/Textarea'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import DtoMatEvent from 'materiel/components/variousMateriel/dto/DtoMatEvent'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoVariousMateriel from 'station/dto/materiel/DtoVariousMateriel'
import ToastrAction from 'toastr/actions/ToastrAction'

const emptyEvent = {
    materielType: 'divers',
    idMateriel: null,
    idType: null,
    eventDate: null,
    comment: null,
}

const MatEventModal = ({
    open = false,
    defaultEvent,
    materiels = [],
    onCancel = () => {},
    onDelete = () => {},
    onValidate = () => {},
}) => {
    const {
        matEventsTypes,
    } = useSelector((store) => ({
        matEventsTypes: store.VariousMaterielReducer.matEventsTypes,
    }), shallowEqual)

    const dispatch = useDispatch()

    const idMateriel = materiels.length ? materiels[0]?.id : null

    const [event, setEvent] = useState(defaultEvent || { ...emptyEvent, idMateriel, idType: 1 })

    const handleChange = (newEvent) => {
        setEvent(prev => ({ ...prev, ...newEvent }))
    }

    const handleCancel = () => {
        setEvent(emptyEvent)
        onCancel()
    }

    const handleDelete = () => {
        setEvent(emptyEvent)
        onDelete(event)
    }

    const handleValidate = () => {
        if (event.idMateriel && event.idType && event.eventDate) {
            setEvent(emptyEvent)
            onValidate({ ...event, eventDate: new Date(event.eventDate).getTime() })
        } else {
            dispatch(ToastrAction.warning(i18n.pleaseCompleteAllRequiredField))
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            style={{ margin: 'auto' }}
            open={open}
            onClose={handleCancel}
        >
            <DefaultDialogTitle
                title={i18n.reportFailure}
                onClose={handleCancel}
            />
            <DialogContent>
                <Stack sx={{ paddingTop: '0.5rem' }}>
                    <Grid2 container columnSpacing={1}>
                        <Grid2 size={4}>
                            <Select
                                id='equipment'
                                required
                                noNullValue
                                label={i18n.equipment}
                                value={event.idMateriel}
                                onChange={(v) => handleChange({ idMateriel: v })}
                                integerValue
                                options={materiels}
                                keyvalue='id'
                                keyLabel='reference'
                                obligatory
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <Select
                                id='idType'
                                required
                                noNullValue
                                label={i18n.eventType}
                                value={event.idType}
                                onChange={(v) => handleChange({ idType: v })}
                                integerValue
                                options={matEventsTypes}
                                keyvalue='id'
                                obligatory
                            />
                        </Grid2>
                        <Grid2 size={4}>
                            <SimpleDatePicker
                                id='eventDate'
                                label={i18n.date}
                                value={event.eventDate}
                                onChange={(v) => handleChange({ eventDate: v })}
                                obligatory
                            />
                        </Grid2>
                    </Grid2>
                    <Textarea
                        id='comment'
                        title={i18n.comment}
                        value={event.comment}
                        onChange={(v) => handleChange({ comment: v })}
                        rows={10}
                    />
                </Stack>
            </DialogContent>
            <DialogActions style={event.id && { justifyContent: 'space-between' }}>
                {event.id && (
                    <Button
                        variant='outlined'
                        className='red'
                        style={{ color: 'white' }}
                        onClick={handleDelete}
                    >
                        {i18n.delete}
                    </Button>
                )}
                <Button
                    variant='contained'
                    color='primary'
                    onClick={handleValidate}
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

MatEventModal.propTypes = {
    open: PropTypes.bool,
    defaultEvent: PropTypes.instanceOf(DtoMatEvent),
    materiels: PropTypes.arrayOf(PropTypes.instanceOf(DtoVariousMateriel)),
    onCancel: PropTypes.func,
    onValidate: PropTypes.func,
    onDelete: PropTypes.func,
}

export default MatEventModal
